<template>
  <a-tabs class="ii-sys-config">
    <a-tab-pane class="basicConfig"
                key="basicConfig"
                size="small"
                :tab="$t('system_config.SystemConfiguration.config')"
                :bordered="false">
      <div class="settings">
        <template v-for="item in settings"
                  :key='item.key'>
          <component :is='`set-${item.type}`'
                     :item='item' />
        </template>
      </div>
    </a-tab-pane>
  </a-tabs>
</template>
<script lang="ts">
import SetBoolean from './components/SetBoolean.vue'
import SetString from './components/SetString.vue'
import SetImage from './components/SetImage.vue'
import SetDatetime from './components/SetDatetime.vue'
export default {
  components: {
    SetBoolean,
    SetDatetime,
    SetImage,
    SetString
  },
}
</script>

<script setup lang="ts">
import { useSysConfig } from '../DefaultSystemPlugin'
import { storeToRefs } from 'pinia'
const sysConfig = useSysConfig()
sysConfig.fetchSysConfig()
const { settings } = storeToRefs(sysConfig)

</script>
<style scoped lang="less">
@import '@/styles/default.less';

.ii-sys-config {
  width: 100%;
  height: 100%;
  background-color: white;

  :deep(.ant-tabs-tab) {
    padding: 12px 12px;
  }

  :deep(.ant-tabs-content-holder) {
    width: 100%;
    height: 100%;
    overflow-y: auto;
  }

  .settings {
    min-width: 500px;
    width: 100%;
    height: 100%;
    max-width: 600px;
    margin: 0 auto;
    color: #595959;
    overflow-y: auto;

    :deep(.item) {
      min-height: 80px;
      padding: 4px 0 4px 0;
      border-bottom: 1px solid @primary-color;
      align-items: center;

      .anticon,
      .iota-icon {
        font-size: 20px;
        color: @primary-color;
      }

      .title {
        font-weight: 500;
      }

      .hint {
        font-size: 12px;
        color: @primary-color;
      }

      &:last-child {
        border: none;
      }
    }
  }
}
</style>
